import { useEffect, useState } from 'react';
import { fetchGoogleCategories, rootCategoryMap } from 'utils/googleCategories';

interface RootCategory {
  name: string;
  icon: string;
  id: string;
}

export interface CategoryNode {
  code: string;
  children: Record<string, CategoryNode> | null;
  category: string;
  level: number;
}

const useLoadCategories = () => {
  const [rootCategories, setRootCategories] = useState<RootCategory[]>([]);
  const [categoryMap, setCategoryMap] = useState(new Map());
  const [categories, setCategories] = useState<CategoryNode>({
    code: '',
    category: '',
    level: 0,
    children: null,
  });

  useEffect(() => {
    const getCategories = async () => {
      // fix this later
      const { trie, map }: any = await fetchGoogleCategories();
      setCategoryMap(map);
      setCategories({
        code: 'root',
        category: 'Root',
        level: 0,
        children: {
          'All Categories': { code: '0', level: 1, children: null, category: 'All Categories' },
          ...trie?.head?.children,
        },
      });
      const rootCats = trie?.head?.children
        ? Object.values(trie?.head?.children as { code: number }[])
            ?.map(({ code }) => {
              const category = rootCategoryMap[code as keyof typeof rootCategoryMap];
              return {
                icon: category?.icon,
                name: category?.name,
                id: category?.id,
              };
            })
            ?.filter((category) => category.name && category.name !== 'Mature')
            ?.sort((a, b) => a.name.localeCompare(b.name)) || []
        : [];
      setRootCategories([{ icon: 'apps', name: 'All Categories', id: '0' }, ...rootCats]);
    };

    getCategories();
  }, []);

  return { rootCategories, categories, categoryMap };
};

export default useLoadCategories;
